import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PartialProcessingBannerProps {
  message: string;
}

export function PartialProcessingBanner({
  message,
}: PartialProcessingBannerProps) {
  const { t } = useTranslation("common");
  return (
    <div className="rounded-card border border-amber-300 bg-amber-50 dark:bg-amber-950/20 dark:border-amber-800 p-4">
      <div className="flex items-start gap-3">
        <AlertTriangle
          size={20}
          className="text-amber-600 dark:text-amber-400 mt-0.5 shrink-0"
        />
        <div className="flex-1">
          <p className="text-[14px] font-medium text-amber-800 dark:text-amber-300">
            {t("partialProcessing.title")}
          </p>
          <p className="text-[12px] text-amber-700 dark:text-amber-400 mt-1">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
